<template>
  <!-- <div class="MyButton"> -->
    <input type="button" name="" :value="value" :style="inputStyle" :disabled="disable" />
    <!-- </div> -->
</template>

<script>
export default {
  name: 'MyButton',
  props: ['value', 'inputStyle', 'disable']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 input{
 /* .MyButton> input{ */
   width: 100%;
   height: 3.02vw;
   font-size:1.15vw;
   color: white;
   border: none;
   background-color: #141414;
   border-radius: 1.51vw;
   cursor: pointer;
 }
 /* .MyButton> input:disabled{ */
 input:disabled{
   background-color: #aaaaaa;
 }

 @media (min-width: 320px) and (max-width: 480px) {
   /* .MyButton> input{ */
 input{
   height: 40px;
   font-size: 20px;
 }
   }
</style>
